import { Grid, TextField } from "@mui/material"
import { useState } from "react"
import Modal from "../ui/Modal"

const initialData = {
  joiningDate: "",
  leavingDate: "",
  designation: "",
  employer: "",
  reasonForLeaving: "",
}

const AddExperience = (props) => {
  const [data, setData] = useState(initialData)
  const handleChange = (e) => {
    const { name, value } = e.target
    setData({
      ...data,
      [name]: value,
    })
  }
  const action = () => {
    props.add(data)
    setData(initialData)
    props.close()
  }
  return (
    <Modal
      {...props}
      title="Add Employment Experience"
      actionText={"Add"}
      action={action}
    >
      <Grid container spacing={2} mt={1}>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Employer"
            name="employer"
            value={data.employer}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Designation"
            name="designation"
            value={data.designation}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            type="date"
            fullWidth
            InputLabelProps={{ shrink: true }}
            label="Joining Date"
            name="joiningDate"
            value={data.joiningDate}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            type="date"
            fullWidth
            InputLabelProps={{ shrink: true }}
            label="Leaving Date"
            name="leavingDate"
            value={data.leavingDate}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Reason for leaving"
            name="reasonForLeaving"
            value={data.reasonForLeaving}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </Modal>
  )
}

export default AddExperience
